import './App.css';
import Header from './components/header/Header';

function App() {
  return (

    <div className="App">
      <Header></Header>
      <div className="mainbody">



      </div>
    </div>
  );
}

export default App;
